import 'babel-polyfill';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import router from 'noc/router';
import store from 'noc/store';
import { InitialiseGoogleUA } from 'noc/common/googleAnalytics';

// require style to generate one css file
require('../styles/main.scss');
require('file?name=[name].[ext]!../index.html');
require('file?name=[name].[ext]!../configs/appSettings/LOCAL/appsettings.js');
require('file?name=../DT/[name].[ext]!../configs/appSettings/DT/appsettings.js');
require('file?name=../DTFT/[name].[ext]!../configs/appSettings/DTFT/appsettings.js');
require('file?name=../DTHF/[name].[ext]!../configs/appSettings/DTHF/appsettings.js');
require('file?name=../PRE/[name].[ext]!../configs/appSettings/PRE/appsettings.js');
require('file?name=../PREHF/[name].[ext]!../configs/appSettings/PREHF/appsettings.js');
require('file?name=../PROD/[name].[ext]!../configs/appSettings/PROD/appsettings.js');
require('file?name=../PRODUS/[name].[ext]!../configs/appSettings/PRODUS/appsettings.js');
require('file?name=../QA/[name].[ext]!../configs/appSettings/QA/appsettings.js');
require('file?name=../QAHF/[name].[ext]!../configs/appSettings/QAHF/appsettings.js');

/* Initialize google analytics */
InitialiseGoogleUA();

const history = syncHistoryWithStore(browserHistory, store);
const rootElement = document.getElementById('root');

if (rootElement) {
    render(<Provider store={store}>{router(history)}</Provider>, rootElement);
}



// WEBPACK FOOTER //
// ./app/main.jsx